import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { ShopViewConstants } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import trafficEvents from '@wsb/guac-widget-shared/lib/common/constants/traffic2';
import dataAids from '../../constants/dataAids';

class Pagination extends React.Component {
  constructor() {
    super(...arguments);
  }

  buildPageRange() {
    const { currentPage, pages, onPageChange } = this.props;
    const { getLinkProps } = this.context;
    const { Block, Link } = UX2.Element;

    const buildEllipsis = (key, onlyMobileVisible = false) => {
      const ellipsisWrapperStyles = {
        'fontColor': 'section',
        'marginLeft': 'xxsmall',
        'paddingVertical': 'xxsmall',
        '@sm': {
          display: onlyMobileVisible ? 'none' : 'inline'
        }
      };
      return (
        <Block key={ `ellipsis-${key}` } style={ ellipsisWrapperStyles }>
          ...
        </Block>
      );
    };

    const buildPageButton = (pageNumber, mobileVisible = true) => {
      const linkProps = getLinkProps(ShopViewConstants.PRODUCT_LISTING, { page: pageNumber });
      const buttonStyles = {
        'borderWidth': '1px',
        'borderStyle': 'solid',
        'borderColor': 'section',
        'cursor': 'pointer',
        'marginLeft': 'xxsmall',
        'padding': 'xxsmall',
        'textAlign': 'center',
        'borderRadius': 'xsmall',
        'fontColor': pageNumber === currentPage ? 'action' : 'section',
        'backgroundColor': pageNumber === currentPage ? 'action' : 'input',
        'minWidth': pages > 99 ? '2.5rem' : '2.75rem',
        '@xs-only': {
          display: mobileVisible ? 'inline' : 'none'
        }
      };
      return (
        <Link
          key={ `button-${pageNumber}` }
          onClick={ e => {
            e.preventDefault();
            onPageChange(pageNumber);
          } }
          href='javascript:;'
          data-Traffic2={ trafficEvents.shop_widget.click_pagination_number }
          data-aid={ `${dataAids.PAGINATION_PAGE_NUMBER}_${pageNumber}` }
          { ...linkProps }
          children={ pageNumber }
          style={ buttonStyles }
        />
      );
    };

    const pageRange = [buildPageButton(1)];

    if (pages > 4) {
      if (currentPage <= 2) {
        pageRange.push(
          buildPageButton(2),
          buildPageButton(3, false),
          buildEllipsis('next')
        );
      } else if (currentPage >= pages - 1) {
        pageRange.push(
          buildEllipsis('prev'),
          buildPageButton(pages - 2, false),
          buildPageButton(pages - 1)
        );
      } else {
        const prevPage = currentPage - 1;
        const nextPage = currentPage + 1;

        if (currentPage === 3) {
          pageRange.push(buildPageButton(prevPage));
        } else if (currentPage === 4) {
          pageRange.push(
            buildEllipsis('prev', true),
            buildPageButton(2, false),
            buildPageButton(prevPage, false)
          );
        } else {
          pageRange.push(buildEllipsis('prev'), buildPageButton(prevPage, false));
        }

        pageRange.push(buildPageButton(currentPage));

        if (currentPage === pages - 3) {
          pageRange.push(
            buildPageButton(nextPage, false),
            buildPageButton(pages - 1, false),
            buildEllipsis('next', true)
          );
        } else if (currentPage === pages - 2) {
          pageRange.push(buildPageButton(nextPage));
        } else {
          pageRange.push(buildPageButton(nextPage, false), buildEllipsis('next'));
        }
      }

      pageRange.push(buildPageButton(pages));
    } else {
      for (var i = 2; i <= pages; i++) {
        pageRange.push(buildPageButton(i));
      }
    }

    return (
      <Block
        data-aid={ dataAids.PAGINATION_PAGE_RANGE }
        children={ pageRange }
        style={{ display: 'flex' }}
      />
    );
  }

  buildArrow(direction) {
    // 'back', 'forward'
    const { currentPage, pages, onPageChange } = this.props;
    const { Link, Icon } = UX2.Element;

    const isDisabled = direction === 'back' ? currentPage === 1 : currentPage === pages;
    const newPage = direction === 'back' ? currentPage - 1 : currentPage + 1;
    const trafficEvent =
      direction === 'back'
        ? trafficEvents.shop_widget.click_pagination_back_arrow
        : trafficEvents.shop_widget.click_pagination_forward_arrow;
    const dataAid =
      dataAids.PAGINATION_ARROW + `${direction === 'back' ? '_BACK' : '_FORWARD'}`;

    const linkProps = this.context.getLinkProps(ShopViewConstants.PRODUCT_LISTING, { page: newPage });

    const styles = {
      display: 'flex',
      width: pages > 99 ? '3.25rem' : '3.5rem',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: direction === 'back' ? 'none' : 'xxsmall',
      paddingVertical: 'xxsmall',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'section',
      borderRadius: 'xsmall',
      fontColor: 'section',
      cursor: 'pointer',
      pointerEvents: isDisabled ? 'none' : 'auto',
      opacity: isDisabled ? '0.5' : '1.0'
    };

    return (
      <Link
        onClick={ e => {
          e.preventDefault();
          onPageChange(newPage);
        } }
        href='javascript:;'
        { ...linkProps }
        data-traffic2={ trafficEvent }
        data-aid={ dataAid }
        style={ styles }
      >
        <Icon
          icon={ direction === 'back' ? 'chevronLeft' : 'chevronRight' }
          size='xsmall'
        />
      </Link>
    );
  }

  render() {
    const { Block } = UX2.Element;

    return (
      <Block data-aid={ dataAids.PAGINATION_RENDERED } style={{ display: 'flex' }}>
        {this.buildArrow('back')}
        {this.buildPageRange()}
        {this.buildArrow('forward')}
      </Block>
    );
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

Pagination.contextTypes = {
  getLinkProps: PropTypes.func
};

export default Pagination;
